var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.085,
    height: 30.085,
    viewBox: "0 0 30.085 30.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55534",
    "data-name": "Group 55534",
    transform: "translate(-228.398 -339.125)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_674",
    "data-name": "Ellipse 674",
    cx: 15.043,
    cy: 15.043,
    rx: 15.043,
    ry: 15.043,
    transform: "translate(228.398 339.125)",
    fill: "#8ba7c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85383",
    "data-name": "Path 85383",
    d: "M124.03,48.636a15.047,15.047,0,0,1-13.37,26.786,15.045,15.045,0,1,0,13.37-26.786Z",
    transform: "translate(124.738 291.46)",
    fill: "#98b2d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_675",
    "data-name": "Ellipse 675",
    cx: 12.211,
    cy: 12.211,
    rx: 12.211,
    ry: 12.211,
    transform: "translate(231.229 341.957)",
    fill: "#92a7c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85384",
    "data-name": "Path 85384",
    d: "M140.235,86.215A12.215,12.215,0,0,1,129.41,107.9a12.213,12.213,0,1,0,10.825-21.686Z",
    transform: "translate(107.26 256.431)",
    fill: "#b1bfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85386",
    "data-name": "Path 85386",
    d: "M168.476,130.646a4.174,4.174,0,0,0-4.17-4.17h-1.191a1.354,1.354,0,1,1,0-2.709h1.191a1.353,1.353,0,0,1,1.248.828,1.408,1.408,0,0,0,2.593-1.1,4.162,4.162,0,0,0-3.03-2.467v-1.067a1.408,1.408,0,0,0-2.815,0v1.067a4.17,4.17,0,0,0,.812,8.26h1.191a1.354,1.354,0,0,1,0,2.709h-1.191a1.347,1.347,0,0,1-1.263-.863,1.408,1.408,0,1,0-2.623,1.023,4.141,4.141,0,0,0,3.074,2.577V135.8a1.408,1.408,0,1,0,2.815,0v-1.067A4.176,4.176,0,0,0,168.476,130.646Z",
    transform: "translate(79.73 226.284)",
    fill: "#b1bfd3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8646940d543e0f4708c6c3a88d7fbf61.svg";
export { ForwardRef as ReactComponent };